import { SearchParams } from "./searchParams";

export class NgSelectProps {
    public items: any[] = [];
    public selectedItems = [];
    public loading = false;
    public itemsHasNext = true;
    public itemParams: any;
    public apiRequest: any;
    public params: any[];


    constructor(apiRequest, p = new SearchParams(), params?: any[]) {
        this.apiRequest = apiRequest;
        this.itemParams = p;
        this.params = params;
    }

    onScroll() {
        if (!this.itemsHasNext) {
            return
        }
        this.itemParams.page++;
        this.loadItems();
    }

    onSearch(e) {
        this.itemParams.search = e.term;
        this.itemParams.page = 1;
        this.items = [];
        if (!this.loading) {
            this.loading = true;
            setTimeout(() => {
                this.loadItems();
            }, 1000);
        }
    }
    loadItems(isOpen = false) {
        if (this.items.length > 0 && isOpen) {
            return;
        }
        this.loading = true;
        const req = this.params ? this.apiRequest(this.itemParams, ...this.params) : this.apiRequest(this.itemParams);
        req.subscribe(
            r => {
                this.loading = false;
                this.itemsHasNext = r.next !== null;
                if (this.items.length > 0) {
                    this.items = this.items.concat(r.results);
                } else {
                    this.items = [...r.results];
                }
            }
        )
    }
    clearSearchParams(reload = true, p = new SearchParams()) {
        this.itemParams = p;
        this.items = [];
        if (reload) {
            this.loadItems();
        }
    }

    addItem(item: any) {
        this.items.unshift(item);
    }
}